import React from 'react';
import CircularSpinner from "@components/spinners/Circular/Circular";

const LoadingSpinner = ({testId}: {testId? : string}) => (
    <div style={{ display: 'flex', justifyContent: 'center', margin: '15vh'}}>
        <CircularSpinner testId={testId} />
    </div>
);

export default LoadingSpinner;
